import { Typography } from "@pondigitalsolutions/pon-component-library";

import { DetailItemProps } from "../types/VacancyTypes";

export const DetailItem = ({
  icon: Icon,
  image,
  children,
}: DetailItemProps) => (
  <Typography
    as="span"
    className="flex items-center text-sm font-normal text-tertiary-700 dark:text-white"
  >
    {Icon && <Icon strokeWidth={1} width={16} height={16} className="mr-1" />}
    {image && <img src={image} alt="" className="mr-1 h-8 w-8" />}
    {children}
  </Typography>
);
